import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Heart, X, Send } from 'lucide-react';

const MobileQuickAction = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const [pulse, setPulse] = useState(true);
  const location = useLocation();

  const hiddenPaths = ['/checkout', '/login', '/signup', '/forgot-password', '/reset-password'];
  const shouldHide = hiddenPaths.some(path => location.pathname.startsWith(path));
  const isOnPrayerPage = location.pathname.startsWith('/prayer-request');

  useEffect(() => {
    const handleScroll = () => setIsVisible(window.scrollY > 200);
    handleScroll();
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsExpanded(false);
  }, [location]);

  // Stop pulse after 5 seconds
  useEffect(() => {
    const timer = setTimeout(() => setPulse(false), 5000);
    return () => clearTimeout(timer);
  }, []);

  if (shouldHide) return null;

  // On prayer request page, show a simple scroll-to-top or nothing
  if (isOnPrayerPage) return null;

  return (
    <>
      {isExpanded && (
        <div className="fixed inset-0 bg-black/50 z-40" onClick={() => setIsExpanded(false)} />
      )}

      <div className={`fixed bottom-6 right-6 z-50 transition-all duration-300 ${
        isVisible ? 'translate-y-0 opacity-100' : 'translate-y-20 opacity-0'
      }`}>
        {isExpanded && (
          <div className="absolute bottom-16 right-0 mb-2 flex flex-col gap-3 items-end animate-in fade-in slide-in-from-bottom-4 duration-200">
            <Link
              to="/prayer-request"
              className="flex items-center gap-2 bg-white text-gray-800 px-4 py-3 rounded-full shadow-lg hover:shadow-xl transition-shadow"
              data-testid="fab-submit-prayer"
            >
              <span className="font-medium">Begin Your Prayer</span>
              <Heart className="h-5 w-5 text-amber-600" />
            </Link>
            <Link
              to="/sacred-sites"
              className="flex items-center gap-2 bg-white text-gray-800 px-4 py-3 rounded-full shadow-lg hover:shadow-xl transition-shadow"
              data-testid="fab-sacred-sites"
            >
              <span className="font-medium">Sacred Sites</span>
              <Send className="h-5 w-5 text-amber-600" />
            </Link>
          </div>
        )}

        <button
          onClick={() => setIsExpanded(!isExpanded)}
          className={`w-14 h-14 rounded-full shadow-lg flex items-center justify-center transition-all duration-300 ${
            isExpanded
              ? 'bg-gray-800 rotate-45'
              : 'bg-gradient-to-br from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700'
          } ${pulse && !isExpanded ? 'animate-bounce' : ''}`}
          aria-label={isExpanded ? 'Close menu' : 'Quick prayer'}
          data-testid="fab-button"
        >
          {isExpanded ? (
            <X className="h-6 w-6 text-white" />
          ) : (
            <Heart className="h-6 w-6 text-white" />
          )}
        </button>
      </div>
    </>
  );
};

export default MobileQuickAction;
